import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShipmentListItemDto } from './models/shipment-list-item.dto';

@Injectable({ providedIn: 'root' })
export class ShipmentsProvider {
  constructor(private http: HttpClient) {}

  getShipments(): Observable<ShipmentListItemDto[]> {
    const url = '/api/shipments';
    return this.http.get<ShipmentListItemDto[]>(url);
  }
}
